var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-chart",style:({ width: _vm.width, height: _vm.height })},_vm._l((_vm.sum),function(i){return _c('div',{key:i,staticClass:"bar",class:{ 'active-bar': _vm.num >= i },style:({ height: _vm.getHeight(i) })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }